import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Phone as PhoneIcon, WhatsApp as WhatsAppIcon } from '@mui/icons-material';
import { handleCall, handleWhatsApp } from './utils';

const GalleryCTA: React.FC = () => {
  return (
    <Paper sx={{ 
      textAlign: 'center', 
      mt: 8, 
      p: 6, 
      background: 'linear-gradient(135deg, #1a237e 0%, #3949ab 100%)',
      borderRadius: '20px',
      color: 'white',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 30% 30%, rgba(255,202,40,0.2) 0%, transparent 50%)',
        zIndex: 1
      }} />
      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <Typography variant="h4" sx={{ 
          fontWeight: 'bold',
          mb: 3,
          background: 'linear-gradient(45deg, #fff, #ffca28)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Transform Your Space with Quality Materials
        </Typography>
        <Typography variant="h6" sx={{ 
          mb: 4,
          maxWidth: '700px',
          mx: 'auto',
          lineHeight: 1.6,
          opacity: 0.9
        }}>
          Whether you're renovating your bathroom, upgrading your kitchen, or building your dream home, 
          we have the perfect materials for every project.
        </Typography>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: 3,
          flexWrap: 'wrap',
          mb: 4
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" sx={{ color: '#ffca28' }}>✓</Typography>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Premium Quality Products
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" sx={{ color: '#ffca28' }}>✓</Typography>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Expert Installation Support
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" sx={{ color: '#ffca28' }}>✓</Typography>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Competitive Pricing
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: '#ffca28',
              color: '#1a237e',
              fontWeight: 'bold',
              borderRadius: '25px',
              px: 4,
              py: 1.5,
              '&:hover': {
                backgroundColor: '#ffd54f',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(255,202,40,0.3)'
              },
              transition: 'all 0.3s ease'
            }}
            onClick={handleCall}
          >
            <PhoneIcon sx={{ mr: 1 }} /> Call Now for Quotes
          </Button>
          <Button
            variant="outlined"
            size="large"
            sx={{
              borderColor: 'white',
              color: 'white',
              fontWeight: 'bold',
              borderRadius: '25px',
              px: 4,
              py: 1.5,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderColor: '#ffca28',
                color: '#ffca28',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.3s ease'
            }}
            onClick={() => handleWhatsApp()}
          >
            <WhatsAppIcon sx={{ mr: 1 }} /> WhatsApp Us
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default GalleryCTA;
